import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ApisService } from '@core/services/apis.service';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-add-alerts',
  templateUrl: './add-alerts.component.html',
  styleUrls: ['./add-alerts.component.scss']
})
export class AddAlertsComponent implements OnInit {

  currentLang = localStorage.getItem('lang') || 'en'; // or however you store it

  employee: any;
  cites: any;
  cities: any;

formData: any = {
    title_ar: '',
  title_en: '',
  body_ar: '',
  body_en: '',
  recipients: 'all',
  type: 'all', // ✅ Default to "All Users"
      user_id: null

};
//  jobTitles: any[] = [
//     { id: 1, name: 'Software Engineer' },
//     { id: 2, name: 'Project Manager' },
//     { id: 3, name: 'UI/UX Designer' }
//   ];

   jobTitles: any[] = [];
    public pages  : any

      public totalItems = 0;

  constructor(
    private router: Router,
    private apisService: ApisService,
    private toastr: ToastrService,private translate: TranslateService
  ) {} 

    ngOnInit(): void {
   this.getTags();
    }

     getTags(){ 
  this.apisService.Users().subscribe({
    next: (response: any) => {
      // The actual array is in response.data.data
      this.pages = response.data;  

      this.totalItems = this.pages.length;
      console.log("pages:", this.pages);
    },
    error: (error: any) => {
      console.log(error);
    }
  }
    
  )
 }

  onFileSelected(event: any): void {
  if (event.target.files.length > 0) {
    this.formData.image = event.target.files[0];
  }
}

    cancel(): void {
      this.router.navigate(['/employees']);
    }
  
    getTranslation(translations: any[], locale: string) {
      return translations.find(translation => translation.locale === locale) || {};
    }


    
    /*----------  Submitting the form  ----------*/
    
    /*----------  Submitting the form  ----------*/
onSubmit(): void {
  const form = new FormData();
  form.append('title_ar', this.formData.title_ar);
  form.append('title_en', this.formData.title_en);
  form.append('body_ar', this.formData.body_ar);
  form.append('body_en', this.formData.body_en);
  form.append('type', this.formData.type);
  
  // ✅ Append user_id only if "specific_user" is selected
  if (this.formData.type === 'specific_user' && this.formData.user_id) {
    form.append('user_id', this.formData.user_id);
  }


  this.apisService.addAlerts(form).subscribe({
    next: (response: any) => {
      this.translate
        .get([
          'MENU.DASHBOARD.NOTIFICATION_SUCCESS_TITLE',
          'MENU.DASHBOARD.NOTIFICATION_SUCCESS_MESSAGE',
        ])
        .subscribe((translations) => {
          this.toastr.success(
            translations['MENU.DASHBOARD.NOTIFICATION_SUCCESS_MESSAGE'],
            translations['MENU.DASHBOARD.NOTIFICATION_SUCCESS_TITLE'],
            {
              positionClass: 'toast-top-center',
              timeOut: 3000,
              progressBar: true,
              closeButton: true,
            }
          );
        });

      // Reset form after success
      this.formData = { title: '', body: '', recipients: 'all', type: 'all' };

            this.router.navigate(['/alerts']);

    },

    error: (error: any) => {
      console.error('Error sending notification:', error);

      this.translate
        .get([
          'MENU.DASHBOARD.NOTIFICATION_ERROR_TITLE',
          'MENU.DASHBOARD.NOTIFICATION_ERROR_MESSAGE',
        ])
        .subscribe((translations) => {
          this.toastr.error(
            translations['MENU.DASHBOARD.NOTIFICATION_ERROR_MESSAGE'],
            translations['MENU.DASHBOARD.NOTIFICATION_ERROR_TITLE'],
            {
              positionClass: 'toast-top-center',
              timeOut: 3000,
              progressBar: true,
              closeButton: true,
            }
          );
        });
    },
  });
}

onSearchUser(search: string): void {
  // Avoid hitting API for empty search
  if (!search.trim()) {
    this.getTags(); // reload all users
    return;
  }

  this.apisService.searchNotification(search).subscribe({
    next: (response: any) => {
      if (response.data && Array.isArray(response.data)) {
        this.pages = response.data;
      } else if (response.data?.data) {
        this.pages = response.data.data;
      }
    },
    error: (error: any) => {
      console.error('Error searching users:', error);
    }
  });
}


}